<template>
  <el-card class="box-card">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }"
        >Panel</el-breadcrumb-item
      >
      <el-breadcrumb-item
        :to="{
          path: '/dashboard/' + $route.params.db + '/plugins/avisos',
        }"
        >Avisos</el-breadcrumb-item
      >
      <el-breadcrumb-item v-if="$route.params.id">Editando Aviso</el-breadcrumb-item>
      <el-breadcrumb-item v-else>Nuevo Aviso</el-breadcrumb-item>
    </el-breadcrumb>
    <br />
    <h2>{{ form.asunto }}</h2>
    <div class="loading" v-loading="true" v-if="loading"></div>

    <el-form
      v-if="!loading"
      @submit.native.prevent="submit"
      ref="form"
      label-position="top"
      id="form"
    >
      <el-row type="flex">
        <el-col>
          <el-form-item label="Periodicidad">
            <el-select v-model="form.periodicidad" placeholder="Select">
              <el-option
                v-for="item in periodicidad"
                :key="item.id"
                :label="item.value"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="form.periodicidad == 3">
          <el-form-item label="Día de cada mes que aparece en el calendario">
            <el-select v-model="form.dia" placeholder="Select">
              <el-option
                v-for="item in dias"
                :key="item.id"
                :label="item.value"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="form.periodicidad == 2">
          <el-form-item label="Día de la semana que aparece en el calendario.">
            <el-select v-model="form.dia_semana" placeholder="Select">
              <el-option
                v-for="i in dias_semana"
                :key="i.id"
                :label="i.value"
                :value="i.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col></el-col>
      </el-row>
      <el-row type="flex">
        <el-col>
          <el-col>
            <el-form-item label="¿Enviar Aviso?">
              <el-switch v-model="form.flag_aviso" active-value="1" inactive-value="0">
              </el-switch>
            </el-form-item>
          </el-col>
        </el-col>
        <el-col v-if="form.flag_aviso == 1"
          ><el-tooltip
            class="item"
            effect="dark"
            content="Días de antelación con las que se envía el aviso"
            placement="top-start"
          >
            <el-form-item label="Dias de antelación ">
              <el-select v-model="form.antelacion" placeholder="Select">
                <el-option
                  v-for="item in antelacion"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-tooltip>
        </el-col>
        <el-col v-if="form.flag_aviso == 1"
          ><el-tooltip
            class="item"
            effect="dark"
            content="Número de veces que se envia el aviso por email, este valor deja de tener efecto, cuando el usuario marca como completado un aviso"
            placement="bottom-start"
          >
            <el-form-item label="Repeticiones">
              <el-select v-model="form.repeticiones" placeholder="Select">
                <el-option
                  v-for="i in repeticiones"
                  :key="i"
                  :label="i"
                  :value="i"
                ></el-option>
              </el-select> </el-form-item
          ></el-tooltip>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col>
          <el-form-item label="Tipo">
            <el-select v-model="form.id_tipo" placeholder="Select">
              <el-option
                v-for="item in tipos"
                :key="item.id"
                :label="item.tipo"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col>
          <el-tooltip
            class="item"
            effect="dark"
            content="Fecha que aparece en el calendario. O si la periodicidad es semanal o mensual, la fecha de inicio."
            placement="top-start"
          >
            <el-form-item label="Fecha Inicio">
              <el-date-picker
                v-model="form.fecha_inicio"
                type="date"
                placeholder="Selecciona una fecha"
                format="dd/MM/yyyy"
                :picker-options="pickerOptions1"
              ></el-date-picker> </el-form-item
          ></el-tooltip>
        </el-col>
        <el-col
          ><el-tooltip
            class="item"
            effect="dark"
            content="Fecha en la que dejan de enviarse avisos."
            placement="top-start"
          >
            <el-form-item label="Fecha Final" v-if="form.periodicidad != 1">
              <el-date-picker
                v-model="form.fecha_fin"
                type="date"
                placeholder="Selecciona una fecha"
                format="dd/MM/yyyy"
                :picker-options="pickerOptions1"
              ></el-date-picker>
            </el-form-item>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="Texto que aparece en el aviso del calendario.">
            <el-input v-model="form.nombre"></el-input>
          </el-form-item> </el-col></el-row
      ><el-row>
        <el-col>
          <el-form-item label="Texto que se envía en el email de aviso">
            <el-input type="textarea" :rows="5" v-model="form.descripcion"> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="Adjunto">
            <el-upload
              :key="reload_upload"
              ref="file"
              action
              :auto-upload="false"
              :multiple="false"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :on-preview="handlePreview"
              :file-list="documento"
              :limit="1"
            >
              <el-button size="small" type="primary">Clic para cargar archivo</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="¿Documento obligatorio?">
            <el-switch
              v-model="form.required_document"
              active-value="1"
              inactive-value="0"
            >
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mb-5">
        <el-col>
          <el-form-item label="Destinatarios">
            <app-modal-add-auth
              :table="tableAuth"
              :data="idAuth"
              v-if="showPermisos"
            ></app-modal-add-auth>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <button type="submit" class="el-button el-button--primary" form="form">
            <span>Guardar</span>
          </button>

          <el-button v-if="!$route.params.section_id" @click="close()"
            >Cancelar</el-button
          >
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
import notificationform from "@/components/Dashboard/home/notificationform";
import addAuth from "@/components/_commons/auth/addAuth";

import ApiService from "@/common/api.service";
import { INTRANET_URL, API_UPLOADS } from "@/common/config";
import { mapGetters } from "vuex";
import moment from "moment-timezone";

import {
  FECTH_TIPO_TEMPLATE_DESKTOP,
  FECTH_PAGINA_ACTIVA,
  FECTH_PAGE,
} from "@/store/actions.type";
import { SET_TIPO_TEMPLATE_DESKTOP } from "@/store/mutations.type";

export default {
  name: "NotificacionesForm",
  components: {
    "app-notification-form": notificationform,
    "app-modal-add-auth": addAuth,
  },
  async created() {
    //if (this.$route.params.id) {
    this.init();
    //  } else {
    this.showPermisos = true;

    //   }

    for (let i = 1; i < 32; i++) {
      this.dias.push({ value: "Día " + i, id: i.toString() });
    }
    this.$root.$on("guardarPermisos", (frm) => {
      this.frm_permisos = frm;
      if (this.$route.params.id === undefined) {
        this.$notify({
          title: "Success",
          message:
            "Se han almacenado los permisos una vez que guardes el Formulario se subiran",
          type: "success",
          position: "top-right",
        });
      } else {
        this.guardarPermisos();
      }
    });
  },
  data() {
    return {
      loading: true,
      tipos: [],
      frm_permisos: [],
      idAuth: 0,
      tableAuth: "plugin_avisos_list",
      showPermisos: false,
      dias: [],
      reload_table: 0,
      show_procesar: false,
      reload_upload: 0,
      documento: [],
      pickerOptions1: {
        firstDayOfWeek: 1,
      },
      showEditPermisos: true,

      // show,s
      showTabla: false,

      // form
      id: null,
      form: {
        antelacion: "0",
        nombre: "",
        descripcion: "",
        dia: "1",
        periodicidad: "1",
        repeticiones: 1,
        fecha_fin: null,
        fecha_inicio: null,
        dia_semana: "1",
        documento: "",
        flag_aviso: 0,
      },

      templates: null,
      errorTitle: false,

      // paginate
      tableData: [],
      routeEdit: false,

      tableDelete: false,
      preview: false,

      // notification
      notification: false,
      notification_id: false,

      periodicidad: [
        { id: "1", value: "Una vez" },
        { id: "2", value: "Semanalmente" },
        { id: "3", value: "Mensualmente" },
      ],
      dias_semana: [
        { id: "1", value: "Lunes" },
        { id: "2", value: "Martes" },
        { id: "3", value: "Miércoles" },
        { id: "4", value: "Jueves" },
        { id: "5", value: "Viernes" },
        { id: "6", value: "Sábado" },
        { id: "7", value: "Domingo" },
      ],
      antelacion: [
        { id: "0", value: "0 días" },
        { id: "1", value: "1 día" },
        { id: "2", value: "2 días" },
        { id: "3", value: "3 días" },
        { id: "4", value: "4 días" },
      ],
      repeticiones: [1, 2, 3, 4, 5],
    };
  },
  methods: {
    async init() {
      this.idAuth = parseInt(this.$route.params.id);
      await this.getTipos();
      if (this.$route.params.id !== undefined) {
        await this.getDesktop();
      }
      this.showPermisos = true;
      this.loading = false;
    },
    handleRemove(file) {
      this.documento = [];
      this.form.documento = "";
    },
    handleChange(file) {
      console.log([file]);
      this.documento = [{ file, field: "documento" }];
    },
    handlePreview(file) {
      window.open(file.url, "_blank");
    },

    async getDesktop() {
      const response = await ApiService.post("dashboard/table", {
        table: "plugin_avisos_list",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.$route.params.id,
      });
      this.form = response.data;
      console.log(this.form.documento);
      if (this.form.documento && this.form.documento != "") {
        this.documento[0] = {
          url: API_UPLOADS + this.form.documento,
          name: "Adjunto",
          status: "success",
        };
        this.reload_upload++;
      }
    },
    async uploadFile(data) {
      const response = await ApiService.post("upload/avisos", data);
      return response.data;
    },

    async enviar() {
      if (this.documento.length > 0) {
        for (const i of this.documento) {
          if (!i.url) {
            if (i.file.size) {
              let data = new FormData();
              data.append("file", i.file.raw);
              data.append("type", "file");
              data.append("domain", localStorage.getItem("project"));
              let documento = await this.uploadFile(data);
              this.form.documento = documento;
            }
          }
        }
      }

      if (this.form.fecha_inicio) {
        this.form.fecha_inicio = moment(this.form.fecha_inicio)
          .tz("Europe/Madrid")
          .format("YYYY-MM-DD");
      }

      if (this.form.fecha_fin) {
        this.form.fecha_fin = moment(this.form.fecha_fin)
          .tz("Europe/Madrid")
          .format("YYYY-MM-DD");
      }
      console.log(this.form);
      const response = await ApiService.post("dashboard/editform", {
        table: "plugin_avisos_list",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.form,
        id: this.$route.params.id,
      });
      let id = response.data;
      if (this.$route.params.id) {
        id = this.$route.params.id;
      }

      if (this.frm_permisos.length > 0 && this.$route.params.id === undefined) {
        const resp = await ApiService.put("dashboard/update-desktop-auth", {
          table: "plugin_avisos_list",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          form: this.frm_permisos,
          id: id,
          tableAuth: "plugin_avisos_list",
        }).then((response) => {
          if (response.data) {
            this.$notify({
              title: "Success",
              message: "Permisos actualizados",
              type: "success",
              position: "top-right",
            });
          }
        });
      }

      // actualizo los items:
      const resp = await ApiService.post("dashboard/plugin/avisos/procesa", {
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),

        id: id,
      });
      if (this.$route.params.id) {
        this.$notify({
          title: "Success",
          message: "Se ha actualizado el Aviso",
          type: "success",
          position: "top-right",
        });
      } else {
        this.$notify({
          title: "Success",
          message: "Se ha creado el Aviso",
          type: "success",
          position: "top-right",
        });
      }
      setTimeout(() => {
        this.$router.replace("/dashboard/" + this.$route.params.db + "/plugins/avisos");
      }, 1000);
    },
    async guardarPermisos() {
      const resp = await ApiService.put("dashboard/update-desktop-auth", {
        table: "plugin_avisos_list",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.frm_permisos,
        id: this.$route.params.id,
        tableAuth: "plugin_avisos_list",
      }).then((response) => {
        if (response.data) {
          this.$notify({
            title: "Success",
            message: "Permisos actualizados",
            type: "success",
            position: "top-right",
          });
        }
      });
    },
    async submit() {
      this.$confirm(
        "Esta acción cambiará todos los items relacionados del calendario, y reiniciará los envios relacionados. ¿Continuar?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.enviar();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Se ha cancelado la modificación.",
          });
        });
    },

    async close() {
      await this.$router.replace(
        "/dashboard/" + this.$route.params.db + "/plugins/avisos"
      );
    },

    async getTipos() {
      const a = await ApiService.post("dashboard/listtable", {
        table: "plugin_avisos_tipo",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        header: [
          {
            title: "#id",
            label: "#id",
            path: "id",
            prop: "id",
            type: "number",
            options: [],
          },
          {
            title: "Tipo",
            label: "Tipo",
            path: "tipo",
            prop: "tipo",
            type: "text",
            options: [],
          },
        ],
      });
      this.tipos = a.data;
    },
  },
};
</script>
<style>
.disabled {
  background-color: #dcdfe6;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/plugins/avisos/form.vue